module.exports = __webpack_public_path__ + "fonts/UTM Nokia.acf46d8.ttf";